import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
// import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import { CircularProgress } from '@mui/material';

export default function AppWidgetSummary({ title, value, sx, loading, ...other }) {
  return (
    <Card
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: "150px",
        p: 4,
        cursor: 'pointer', // Makes the cursor a pointer when hovered
        transition: 'box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out', // Smooth transition for visual effects
        '&:hover': {
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', // Shadow effect on hover
          backgroundColor: '#f0f0f0', // Optional: background color change on hover
        },
        ...sx,
      }}
      {...other}
    >
      <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          {title}
        </Typography>
        {/* <Stack direction="row" alignItems="center" sx={{ mb: 1 }}> */}
        {/* <Typography component="div" variant="subtitle2"></Typography> */}
        {/* </Stack> */}
        {loading ? (
          <CircularProgress color="inherit" />
        ) : (
          <Typography variant="h3">{value}</Typography>
        )}
      </Box>
    </Card>
  );
}

AppWidgetSummary.propTypes = {
  value: PropTypes.number,
  sx: PropTypes.object,
  title: PropTypes.string,
  loading: PropTypes.any,
};
